// DS2 Loading Spinner: a turning ring. delayed: ms before it shows (a short wait shows nothing); size: default | small.
// role status, labelled by label (default: "Loading" in the user's language).
import cx from "classnames";
import { useEffect, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import styles from "./LoadingSpinner.module.css";

export type LoadingSpinnerSize = "small" | "default";

export type LoadingSpinnerProps = {
  delayed?: number;
  size?: LoadingSpinnerSize;
  label?: string;
  className?: string;
};

export function LoadingSpinner({
  delayed = 1,
  size = "default",
  label,
  className,
}: LoadingSpinnerProps) {
  const { loadingLabel } = useI18n().translation.designSystem;
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShown(true), delayed);
    return () => clearTimeout(t);
  }, [delayed]);
  if (!shown) return null;
  const resolvedLabel = label ?? loadingLabel;
  const small = size === "small";
  return (
    <svg
      className={cx(styles.spinner, small && styles.small, className)}
      viewBox="0 0 36 36"
      role="status"
      aria-label={resolvedLabel}
    >
      <circle className={styles.track} cx="18" cy="18" r="16.2" fill="none" strokeWidth="3.6" />
      <path className={styles.arc} d="M34.2 18A16.2 16.2 0 0 1 1.8 18" fill="none" strokeWidth="3.6" />
    </svg>
  );
}
